import { Injectable } from '@angular/core';
import { AuthenticatedHttpService, OfflineWrapResult } from './authenticatedHttpService.service';
import { Booking } from 'src/shared/models/booking.model';
import { environment } from 'src/environments/environment';
import { BookingResponse } from 'src/shared/models/bookings-response/booking-response';
import { Allocation } from 'src/shared/models/bookings/allocation.model';
import { PersonModel } from 'src/shared/models/person/person.model';
import { HttpUtils } from 'src/shared/utils/http-utils';
import { BookingCode } from 'src/shared/models/bookings/booking-code.model';

@Injectable({ providedIn: 'root' })
export class BookingProvider {
  static readonly ALLOCATIONS = 'ALLOCATIONS';
  static readonly BOOKING_CODES = 'BOOKING_CODES';

  constructor(private http: AuthenticatedHttpService) {}

  async bookData(currentBooking: Booking): Promise<BookingResponse> {
    return this.http.post(
      environment.web.apiUrl + 'bookings',
      JSON.stringify(currentBooking, this.replacer)
    );
  }

  async getLastBooking(): Promise<Booking> {
    return await this.http.get(environment.web.apiUrl + 'bookings/last');
  }

  async getAllocations(): Promise<Array<Allocation>> {
    const res = await this.http.wrapIntoOffline<Array<Allocation>>({
      fetch: this.http.get,
      params: [environment.web.apiUrl + 'me/allocations'],
      storeKey: BookingProvider.ALLOCATIONS,
    });

    if (res.status === OfflineWrapResult.Error) throw res.error;

    return res.result || [];
  }

  async getBookingCodes(): Promise<Array<BookingCode>> {
    const res = await this.http.wrapIntoOffline<Array<BookingCode>>({
      fetch: this.http.get,
      params: [environment.web.apiUrl + 'me/booking-codes'],
      storeKey: BookingProvider.BOOKING_CODES,
    });

    if (res.status === OfflineWrapResult.Error) throw res.error;

    return res.result || [];
  }

  async checkPersonnelNumber(personnelNumber: string) {
    try {
      return await HttpUtils.handle<PersonModel>({
        request: this.http.get(`${environment.web.apiUrl}me/multiuserbooking/${personnelNumber}`),
      });
    } catch (error) {
      return null;
    }
  }

  private replacer(key: any, value: any) {
    if (value === null) {
      return undefined;
    }
    return value;
  }
}
